export enum DynamicDocumentType {
    COOPERATION_AGREEMENT = 1,
}
